import React from "react"
import { Redirect } from "react-router"

const Home: React.FC = () => {
    return <Redirect to="/project" />
}

export default Home
